export const defaultConfig = {
    landbot: {
        oneway: {
            en: {id: "H-1525326-5FSDRZOPTIBTND9M", baseUrl: "https://storage.googleapis.com/landbot.pro/v3/"},
            fi: {id: "H-1104294-9R3ZP3TR0R6XU7DL", baseUrl: undefined}
        },
    }
};